import { buildScopedI18n } from '../../utils/buildScopedI18n';
import arEsCL from './locales/es-CL.json';
import arEnUS from './locales/en-US.json';
import arPtBR from './locales/pt-BR.json';

export const approvalRequestI18n = buildScopedI18n({
  esCL: arEsCL,
  enUS: arEnUS,
  ptBR: arPtBR,
});
